<template>
  <div class="HeaderSide">
    <div class="btnList">
      <!-- 2차 개발
      <v-menu
        v-model="showNoticeLayer"
        :close-on-content-click="false"
        :nudge-width="264"
        :nudge-bottom="60"
        content-class="sideHaderLayer"
        offset-x
      >
        <template v-slot:activator="{ on }">
          <v-btn flat icon v-on="on"><i class="UXicon-notifications_outlined"><span class="num">3</span></i></v-btn>
        </template>

        <v-card class="noticeLayer">

          <VuePerfectScrollbar style="padding-right:10px;height:285px;">
            <div class="list">
              <div class="callNoticeToast callIcon">
                <dl class="warningIcon">
                  <dt>예약 <strong>5분전</strong> 알림입니다.</dt>
                  <dd class="data">05.06 <span>11:00</span></dd>
                  <dd><a>콜백 조회하기</a></dd>
                </dl>
                <div class="close"><v-btn flat icon><v-icon>close</v-icon></v-btn></div>
              </div>
              <div class="callNoticeToast callIcon">
                <dl class="successIcon">
                  <dt>전화가 <strong>수신중</strong> 입니다.</dt>
                  <dd class="data">05.06 <span>11:00</span></dd>
                </dl>
                <div class="close"><v-btn flat icon><v-icon>close</v-icon></v-btn></div>
              </div>
              <div class="callNoticeToast callIcon">
                <dl class="successIcon">
                  <dt>전화가 <strong>수신중</strong> 입니다.</dt>
                  <dd class="data">05.06 <span>11:00</span></dd>
                </dl>
                <div class="close"><v-btn flat icon><v-icon>close</v-icon></v-btn></div>
              </div>
              <div class="callNoticeToast callIcon">
                <dl class="successIcon">
                  <dt>전화가 <strong>수신중</strong> 입니다.</dt>
                  <dd class="data">05.06 <span>11:00</span></dd>
                </dl>
                <div class="close"><v-btn flat icon><v-icon>close</v-icon></v-btn></div>
              </div>
              <div class="callNoticeToast callIcon">
                <dl class="successIcon">
                  <dt>전화가 <strong>수신중</strong> 입니다.</dt>
                  <dd class="data">05.06 <span>11:00</span></dd>
                </dl>
                <div class="close"><v-btn flat icon><v-icon>close</v-icon></v-btn></div>
              </div>
              <div class="callNoticeToast">
                <dl class="infoIcon">
                  <dt>콜백이 할당 되었습니다.</dt>
                  <dd class="data">05.06 <span>11:00</span></dd>
                  <dd><a>콜백 조회하기</a></dd>
                </dl>
                <div class="close"><v-btn flat icon><v-icon>close</v-icon></v-btn></div>
              </div>
              <div class="callNoticeToast callIcon">
                <dl class="infoIcon">
                  <dt>예약 <strong>5분전</strong> 알림입니다.</dt>
                  <dd class="data">05.06 <span>11:00</span></dd>
                </dl>
                <div class="close"><v-btn flat icon><v-icon>close</v-icon></v-btn></div>
              </div>
              <div class="callNoticeToast callIcon">
                <dl>
                  <dt>예약 <strong>5분전</strong> 알림입니다.</dt>
                  <dd class="data">05.06 <span>11:00</span></dd>
                  <dd><a href="">콜백 조회하기</a></dd>
                </dl>
                <div class="close"><v-btn flat icon><v-icon>close</v-icon></v-btn></div>
              </div>
            </div>
          </VuePerfectScrollbar>
          <div class="cenBtn">
            <v-btn round dark large color="#6D8DFF" class="UXbtn" @click="showNoticeLayer = false">확인</v-btn>
          </div>
        </v-card>
      </v-menu>
      -->
      <v-tooltip v-if="lookInBrandResult"
        content-class="UXTooltip  fixed"
        bottom
      >
        <template v-slot:activator="{ on }">
          <v-btn flat icon v-on="on" @click="lookInBrandExitProcess" class="v-btn--back">戻る<i class="UXicon-return" style="font-size: 17px;margin-left: 4px;"></i></v-btn>
        </template>
        <span>管理者センターに戻る</span>
      </v-tooltip>
      <div class="monitoring" v-if="lookInBrandResult">モニタリング中<i class="UXicon-component_max" style="margin-left: 8px;font-size: 16px;"></i></div>
      <div class="userblockBtnWrap">
          <v-menu
          v-model="showUserLayer"
          :close-on-content-click="false"
          :close-on-click="false"
          :nudge-width="264"
          :nudge-bottom="60"
          content-class="sideHaderLayer"
          offset-x
        >
          <template v-slot:activator="{ on }">
            <v-tooltip
              content-class="UXTooltip fixed"
              bottom
            >
              <template v-slot:activator="{ on }">
                <v-btn flat icon v-on="on" class="headerBtn" @click="getData"><i class="UXicon-headset"></i></v-btn>
              </template>
              <span>マイアカウント</span>
            </v-tooltip>
          </template>
          <v-card class="userLayer">
            <!-- 유저 설정 팝업 -->
            <v-tabs v-model="userTab" class="UXTab">
              <v-tab href="#PROFILE">個人情報</v-tab>
              <v-tab href="#STATUS">マイステータス</v-tab>
  <!--            <v-tab href="#NOTICE">알림설정</v-tab>-->
            </v-tabs>
            <div class="statisBox" v-show="userTab === 'STATUS'">
              <div class="select" @click="() => { if (!isSummaryCompleted) { $toasted.error(`相談内容登録後に状態変更が可能です。`) } }">
                <v-select
                  :disabled="!isSummaryCompleted"
                  v-model="userStatusItem"
                  :items="agentStatuses"
                  item-text="statusType"
                  item-value="statusType"
                  class="UXselect"
                  :menu-props="{contentClass:'UXselectFixed'}"
                  color="#6D8DFF"
                  hide-details
                  outline
                  solo
                  no-data-text="データがありません。"
                ></v-select>
              </div>
              <dl class="txt" v-if="!$targetMake.isSeller">
                <dt><span>Tip.</span> コール相談のご案内</dt>
                <dd>· コールチャネルを使用する場合は '相談中'に変更するとステータスが自動的に <strong>'待機'</strong> 状態に変更され分配されます。</dd>
              </dl>
              <div class="cenBtn">
                <v-btn round large outline class="UXbtn widthAuto" @click="showUserLayer = false">キャンセル</v-btn>
                <v-btn round dark large color="#FF8C8C" class="UXbtn widthAuto" @click="saveChangeWorkingStatus(userStatusItem)">確認</v-btn>
              </div>
            </div>
            <div class="noticeBox" v-show="userTab === 'NOTICE'">
              <dl>
                <dt>
                  <v-checkbox
                    label="受信通知"
                    class="UXcheckbox"
                    hide-details
                  ></v-checkbox>
                </dt>
                <dd>他のチャネルの相談中にも受信通知を受けることができます。</dd>
              </dl>
              <dl>
                <dt>
                  <v-checkbox
                    label="予約相談の割当て通知"
                    class="UXcheckbox"
                    hide-details
                  ></v-checkbox>
                </dt>
                <dd>管理者は、アウトバウンドのための一括登録後に予約相談を割当てたときに通知を受け取ることができます。</dd>
              </dl>
              <dl>
                <dt>
                  <v-checkbox
                    label="予約相談通知"
                    class="UXcheckbox"
                    hide-details
                  ></v-checkbox>
                </dt>
                <dd>電話予約相談登録時に予約通知を受け取ることができます。</dd>
                <dd>
                  <v-btn-toggle class="UXbtnToggle">
                  <v-btn flat>5分前</v-btn>
                  <v-btn flat>10分前</v-btn>
                  <v-btn flat>15分前</v-btn>
                  <v-btn flat>20分前</v-btn>
                  </v-btn-toggle>
                </dd>
              </dl>
              <dl>
                <dt>
                  <v-checkbox
                    label="返信メッセージの通知"
                    class="UXcheckbox"
                    hide-details
                  ></v-checkbox>
                </dt>
                <dd>Talk 相談中に本人が送信したメッセージに返信がある場合は、通知を受け取ることができます。</dd>
              </dl>
              <div class="cenBtn">
                <v-btn round large outline class="UXbtn widthAuto" @click="showUserLayer = false">キャンセル</v-btn>
                <v-btn round dark large color="#FF8C8C" class="UXbtn widthAuto" @click="showUserLayer = false">確認</v-btn>
              </div>
            </div>
            <new-user-info ref="newUserInfoRef"  :controlStatus="userTab" v-show="userTab === 'PROFILE'"></new-user-info>
            <!-- //유저 설정 팝업 -->
            <div class="userLayerClose">
              <v-btn flat icon @click="showUserLayer = false">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </v-card>
        </v-menu>
        <v-btn class="userStatseTxt btn" :class="{on: agentWorkingStatus === '相談中'}" @click="showUserLayer = true, userTab = 'STATUS'">{{agentWorkingStatus}}</v-btn>
        <v-tooltip
          content-class="UXTooltip  fixed"
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-btn flat icon v-on="on" @click="logoutProcess"><i class="UXicon-logout"></i></v-btn>
          </template>
          <span>ログアウト</span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import Helpers from '@/util/helpers'
import Util from '@/util'
import {mapGetters, mapMutations} from 'vuex'
import userInfo from './user_info'
import newUserInfo from './new_user_info'
import eventBus from '@/event_bus'
import { cstaDefs } from '@/util/call/netDialAPI'
import apiEvent from '@/util/call/apiEvent'

export default {
  props: ['mode'],
  data () {
    return {
      showNoticeLayer: false,
      showUserLayer: false,
      showMenu: false,
      userTab: 'PROFILE',
      userStatusItem: null,
      agentStatuses: [],
      callAgentStatuses: [
        { id: 1, statusType: '待機', parentMode: cstaDefs.AgentMode.AM_READY, subMode: '' }
      ],
      ktCallAgentStatuses: [
        { id: 1, statusType: '待機', parentMode: 1, subMode: '' },
        { id: 10, statusType: '他業務', parentMode: 2, subMode: '01' },
        { id: 2, statusType: '昼休憩中', parentMode: 2, subMode: '02' },
        { id: 3, statusType: '休憩中', parentMode: 2, subMode: '03' },
        { id: 7, statusType: '離席', parentMode: 2, subMode: '04' },
        { id: 8, statusType: '教育中', parentMode: 2, subMode: '05' },
        { id: 9, statusType: '面談中', parentMode: 2, subMode: '06' },
        { id: 4, statusType: '会議中', parentMode: 2, subMode: '08' },
        { id: 6, statusType: '相談準備', parentMode: 2, subMode: '09' }
      ],
      currentStatus: {},
      statusIcon: 'zmdi zmdi-tag zmdi-hc-lg',
      userLinks: [
        {
          id: 100,
          title: 'プロフィールの修正',
          icon: 'zmdi zmdi-edit zmdi-hc-lg',
          path: ''
        },
        {
          id: 110,
          title: 'Today 相談要約ウィンドウ',
          icon: 'zmdi zmdi-tv zmdi-hc-lg',
          path: ''
        },
        {
          id: 200,
          title: 'ログアウト',
          icon: 'zmdi zmdi-power zmdi-hc-lg'
        }
      ],
      agent: {
        id: -1,
        name: '',
        email: ''
      },
      statusColor: '',
      agentInfoDialogOpened: '',
      chartColors: [
        '#4EAFF7',
        '#37d4bb',
        '#f3b16a',
        '#ff7667',
        '#9dd0eb',
        '#ced1fc',
        '#f9cdd9',
        '#be7ca5',
        '#362b7c',
        '#4775cc',
        '#9db8eb',
        '#6264b0',
        '#ffba90',
        '#d43753',
        '#ff637b',
        '#ff90a3',
        '#512572',
        '#74559b'
      ],
      lookInBrandResult: false
    }
  },
  components: {
    userInfo,
    newUserInfo
  },
  watch: {
    showUserLayer (val) {
      if (val) {
        this.userStatusItem = this.agentWorkingStatus
      }
    }
  },
  created () {
    if (!localStorage.getItem('token')) { return }
    this.axios.get('/api/brand/workingStatusList').then(res => {
      const data = res.data.data
      data.forEach(status => {
        this.agentStatuses.push({
          id: status.id,
          statusType: status.statusType,
          color: this.chartColors[status.id % 20]
        })
      })
    }).then(() => this.fetchCallWorkingStatusList())
      .then(() => this.fetchAgentWorkingStatus())

    eventBus.$on('user-status-update', () => {
      this.fetchAgentWorkingStatus()
    })

    this.$eventBus.$on('closeUserLayer', () => {
      this.showUserLayer = false
    })

    const tokenInfo = Util.parseLoginToken()
    this.agent.id = tokenInfo.agentId
    this.agent.name = tokenInfo.name
    this.agent.email = tokenInfo.email

    eventBus.$on('user-info-dialog-close', () => {
      this.agentInfoDialogOpened = false
    })

    this.isLookInBrand()
  },
  mounted () {
    eventBus.$on('user-status-change', (type) => {
      this.changeWorkingStatus(type)
    })
  },
  destroyed () {
    eventBus.$off('user-status-update')
    eventBus.$off('user-status-change')
    eventBus.$off('closeUserLayer')
  },
  computed: {
    ...mapGetters([
      'isAdministratorRole',
      'agentWorkingStatus',
      'callLoginId',
      'isAvailableCall',
      'callAgentStatus',
      'isSummaryCompleted',
      'callApiUrl',
      'selectedInquiry',
      'selectedInquiryInputStatus',
      'callMode'
    ]),
    textColor () {
      return this.$props.mode === 'operator' ? 'color: white;' : ''
    }
  },
  methods: {
    ...mapMutations([
      'setAgentWorkingStatus',
      'changeCallAgentStatus',
      'resetSelectedInquiry'
    ]),
    // マイアカウントボタン押す時
    getData () {
      this.showUserLayer = true
      this.userTab = 'PROFILE'
      this.$refs.newUserInfoRef.loadAgentInfo()
    },
    showMenuClick () {
      this.showMenu = true
    },
    fetchCallWorkingStatusList () {
      if (this.callMode === 'KT') {
        this.callAgentStatuses = this.ktCallAgentStatuses
      } else {
        if (!this.callApiUrl) return
        this.axios.get('/gateway/call/agent/working-status').then(res => {
          if (res.data.code === 0) {
            const data = res.data.data.filter(status => Helpers.isStringValid(status.remark2))
            data.forEach(callStatus => {
              const cgStatus = this.agentStatuses.find(status => status.id.toString() === callStatus.remark1)
              if (Helpers.isObjectValid(cgStatus)) {
                this.callAgentStatuses.push({id: cgStatus.id, statusType: cgStatus.statusType, parentMode: cstaDefs.AgentMode.AM_NOT_READY, subMode: callStatus.minorCd})
              }
            })
          }
        })
      }
    },
    fetchAgentWorkingStatus () {
      this.axios.get('/api/agent/fetchAgentWorkingStatus').then(res => {
        if (res.status !== 200 || res.data.code !== 0) {
          this.$alertMsg(res.data.message || res.statusText)
          return
        }
        this.agentStatuses.forEach(status => {
          status.checked = false
          status.color = this.chartColors[status.id % 20]
        })

        this.setAgentWorkingStatus(res.data.data.statusType)
        const currentStatus = this.agentStatuses.find(status => status.statusType === this.agentWorkingStatus)
        this.statusColor = currentStatus.color
        currentStatus.checked = true
        this.userStatusItem = currentStatus.statusType
      })
    },
    logoutUser () {
      const haveToken = !!localStorage.getItem('token')
      const isAdmin = this.isAdministrator()
      this.$store.dispatch('setMiniSidebarLayout', false)
      if (this.$store.getters.callMode === 'KT') {
        this.$store.commit('CLOSE_CALL')
        this.$store.commit('SET_CALL_API_URL', '')
      }
      if (!haveToken) {
        this.$router.push('/member/login')
        return
      }
      this.$store.dispatch('logout').then(res => {
        if (res) {
          if (isAdmin) {
            this.$router.push('/member/adminLogin')
          } else {
            this.$router.push('/member/login')
            this.$logReport.write('[LOGOUT]')
          }
        }
      })
    },
    isAdministrator () {
      return this.isAdministratorRole
    },
    saveChangeWorkingStatus (type) {
      if (!this.isSummaryCompleted) {
        this.$toasted.error(`相談内容登録後に状態変更が可能です。`)
        return
      }
      this.changeWorkingStatus(type)
    },
    changeWorkingStatus (type) {
      const selectedStatus = this.agentStatuses.find(status => status.statusType === type)
      this.axios.post('/api/agent/v2/changeWorkingStatus', {
        statusType: type
      }).then(res => {
        if (res.status !== 200 || res.data.code !== 0) {
          this.$alertMsg(res.data.message || res.statusText)
          return
        }
        this.changeCallWorkingStatus(selectedStatus.id)
        this.agentStatuses.forEach(status => {
          status.checked = false
          status.color = this.chartColors[status.id % 20]
        })
        selectedStatus.checked = true
        this.statusColor = selectedStatus.color
        this.setAgentWorkingStatus(selectedStatus.statusType)
        this.userStatusItem = selectedStatus.statusType
        this.showUserLayer = false
      })
    },
    changeCallWorkingStatus (statusId) {
      if (this.callAgentStatus === '通話中') {
        this.$logReport.write(`[EMIT]CONNECTION - originated-completed`)
        this.$eventBus.$emit('call-connection', 'originated-completed')
        return
      }

      const selectedStatus = this.callAgentStatuses.find(status => status.id === statusId)
      if (this.isAvailableCall) {
        let { parentMode } = selectedStatus
        apiEvent.setAgentState(parentMode, this.callLoginId, selectedStatus.subMode)
        this.$logReport.write(`[CHANGE-AGENT]${selectedStatus.statusType}`)
        this.changeCallAgentStatus(selectedStatus.statusType)
      }
    },
    openStatusScreen () {
      window.open(process.env.BASE_URL + '/todaySummary', '_blank')
    },
    isLookInBrand () {
      this.axios.get('/api/systemLoginInfo/getAdminLogin', {
        params: {
          agentId: Util.parseLoginToken().agentId
        }
      }).then(result => {
        if (result.status !== 200 || result.data.code !== 0) {
          this.lookInBrandResult = false
        } else {
          if (result.data.data) {
            this.lookInBrandResult = true
            localStorage.setItem('lookInBrandResult', true)
          } else {
            this.lookInBrandResult = false
          }
        }
      })
    },
    lookInBrandExitProcess () {
      this.axios.get('/api/agent/getLookInBrandBeforeAgent', {
      }).then(result => {
        if (result.status !== 200 || result.data.code !== 0) {
          this.$alertMsg('ブランド切替終了エラー（元のユーザ情報の取得に失敗）')
          return false
        } else {
          if (result.data.data.isBereforeAgentUsing === true) {
            this.$alertMsg('元のユーザが使用されているため戻ることができません。<br>終了する場合はログアウトしてください。')
            return false
          }

          this.$store.dispatch('logout')
            .catch(res => {
              return false
            })
            .then(res => {
              if (res === false) { // エラー時はcatchで返却した値がセットされる
                // 初回はこのメッセージではなく発生例外のメッセージが表示される（アプリのバグ）
                this.$alertMsg('ブランド切替終了エラー（現ユーザのログアウトに失敗）')
                return false
              }
              this.$logReport.write('[LOGOUT]')
              this.$store.dispatch('login', {
                loginId: result.data.data.loginId,
                password: result.data.data.password,
                isAdminLogin: true
              }).then(res2 => {
                if (!res2.isSuccess) {
                  this.$alertMsg('ブランド切替エラー（元のユーザのログインに失敗）')
                  return false
                } else {
                  this.$logReport.write('[LOGIN]')
                  window.location = '/admin/brand/brand_management'
                }
              })
            })
        }
      })
    },
    logoutProcess () {
      if (this.selectedInquiryInputStatus) {
        return this.$confirmMsg('', this.selectedInquiryInputStatus === 'MODIFY' ? '修正された回答内容があります。<br/>?' : '作成された回答内容があります。<br/>回答を登録せずに閉じますか?', () => {
          this.$eventBus.$emit('closeAnswer', this.logoutUser)
        }, '確認')
      }

      if (this.selectedInquiry.inquiryId) {
        this.$eventBus.$emit('closeAnswer', this.logoutUser)
      } else {
        this.logoutUser()
      }
    }
  }
}
</script>

<style>
  .profile-wrap{
    width: 210px;
    padding: 10px;
    margin-left: -10px;
  }

  .userblock-dropdown{
    position: fixed !important;
    top: 56px !important;
    right: 30px !important;
    left: auto !important;
    min-width: 225px !important;
    transform-origin: right top !important;
  }

  .brand-name-circle-01{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    vertical-align: middle;
  }

  .monitoring {
    position: absolute;
    width: fit-content;
    height: fit-content;
    top: 0;
    margin: auto;
    left: 0;
    right: 80px;
    background: #e5470b;
    color: #fff;
    padding: 4px 10px 4px 14px;
    box-sizing: border-box;
    border-radius: 5px;
    font-size: 12px;
    display: flex;
    align-items: center;
  }
  @media all and (max-width:600px){
    .profile{
      display: none;}
  }
</style>



// WEBPACK FOOTER //
// src/components/templates/header/fragments/user_block.vue